export default {
  "reliefFundActivity.thead.index": "#序号",
  "reliefFundActivity.thead.betProviderType": "有效打码平台",
  "reliefFundActivity.thead.deductBonus": "扣除优惠",
  "reliefFundActivity.thead.rewardCycle": "奖励周期",

  "reliefFundActivity.thead.dailyRewardLimit": "每日奖励上限",
  "reliefFundActivity.thead.weeklyRewardLimit": "每周奖励上限",
  "reliefFundActivity.thead.monthlyRewardLimit": "每月奖励上限",
  "reliefFundActivity.thead.bonusWay": "奖励方式",
  "reliefFundActivity.thead.lossAmount": "亏损金额",
  "reliefFundActivity.thead.returnValue": "返利比例",
  "reliefFundActivity.thead.returnValue2": "返利金额",
  "reliefFundActivity.thead.rollover": "流水倍数",
  "reliefFundActivity.thead.action": "操作",
  "reliefFundActivity.add": "添加",
  "reliefFundActivity.delete": "删除",
};
